import React, { Component } from 'react';

import FieldValue from './FieldValue';

class Field extends Component {
    render() {
        if (!this.props.visible) return null;

        return (
            <>
                <div className="row">
                    <div className={'col-12 col-md-3' + (window.bootstrap.md.matches ? '' : ' small')}>{this.props.name}</div>
                    <div className="col-12 col-md-9"><FieldValue {...this.props} /></div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-md-3"></div>
                    <div className="col-12 col-md-9 small">{this.props.children}</div>
                </div>
            </>
        );
    }
}

export default Field;